export default __webpack_public_path__ + "static/media/cplusplus.3398ef50.svg";